import { render, staticRenderFns } from "./LearningCurve.vue?vue&type=template&id=1230f9df&"
import script from "./LearningCurve.vue?vue&type=script&lang=js&"
export * from "./LearningCurve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LearningCurve.vue"
export default component.exports